!function(global) {
  'use strict';

  var previousFiltersCompanies = global.FiltersCompanies;

  function FiltersCompanies(options) {
    var options = options || {};
    var currentCompany = '';
    var $conf;
    var $modal;
    var $bar;
    var bhCompanies;
    var getCompanies;
    var $taCompanies;
    var hbCompaniesRequest;
    var companyNames = [];
    var selectedFilters;
    var $selectsSector;
    var callback;

    function normalize(str){
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }

    function init() {
      var notFoundCopy;
      // DevComment: console.group('MODULE INITIALIZATION: Filters');
      $conf = options.$conf;
      $modal = options.$modal;
      $bar = options.$bar;
      // Check that callback is not undefined and it is a function
      callback = options.callback;
      selectedFilters = options.selectedFilters;

      $taCompanies = $modal.find('.js-typeahead').add($bar.find('.js-typeahead'));
      $selectsSector = $modal.find('.js-sector').add($bar.find('.js-sector'));

      notFoundCopy = $conf.data('resources').taCompaniesNotFound;

      // Common Bloodhound
      // TODO: get prefetch url from dom
      bhCompanies = new Bloodhound({
          //datumTokenizer: Bloodhound.tokenizers.whitespace,
          datumTokenizer: function (data) {
              companyNames.push(data.name);
              const normalized = normalize(data.name);
              return Bloodhound.tokenizers.whitespace(normalized);
          },
          queryTokenizer: function (q) {
              const normalized = normalize(q);
              return Bloodhound.tokenizers.whitespace(normalized);
          },
        prefetch: options.webapiCompanies,
        ttl: 86400000
      });

      // Set typeahead
      $taCompanies.typeahead(
        {
          minLength: 0,
          highlight: true
        },
        {
          name: 'search',
          displayKey: 'name',
          limit: 10,
          // source: bhCompanies
          source: function (q, sync) {
            if (q === '') {
              sync(bhCompanies.index.all().slice(0, 1));
            }
            else {
              bhCompanies.search(q, sync);
            }
          },
          templates: {
            notFound: '<div class="tt-suggestion tt-notfound">'+notFoundCopy+'</div>'
          }
        }
      );

      hbCompaniesRequest = bhCompanies.initialize();

        hbCompaniesRequest.done(function() {
            currentCompany = companyNames[0];
            $taCompanies.typeahead('val', currentCompany);
        });
        if (options.selectedFilters.companyName !== '') {
            currentCompany = options.selectedFilters.companyName;
            $taCompanies.typeahead('val', currentCompany);
        }

        // Set bindings
      // DevComment: console.log('Binding: %cTypeahead', 'font-weight: bold;');
      $taCompanies
        .on('typeahead:select', function(event, suggestion) {
          // Send selected value to controller
          // DevComment: console.log('%cSelected value: ', 'font-weight: bold;', suggestion);
          $selectsSector.val(0);
          callback('companyName', suggestion.id);

          currentCompany = suggestion.name;
          $taCompanies.blur();

          closeModal();
        })
        .on('typeahead:active', function() {
          $taCompanies.typeahead('val', '');
        })
        .on('blur', function() {
          $taCompanies.typeahead('val', currentCompany);
        });

      // DevComment: console.log('Binding: %cSelects', 'font-weight: bold;');
      $selectsSector.on('change', function(event) {
        // Send selected value to controller
        // DevComment: console.log('%cSelected value: ', 'font-weight: bold;', this.value);
        currentCompany = companyNames[0];
        $taCompanies.typeahead('val', currentCompany);
        callback('industryId', this.value);

        closeModal();
      });

      // DevComment: console.groupEnd();
    }

    function closeModal() {
      $modal.modal('hide');
    }
    /*
      Set binding with a callback
    */
    function setBinding(callback) {}
    function getCurrentValues() {}
    function cleanFilters() {
      currentCompany = companyNames[0];
      $taCompanies.typeahead('val', currentCompany);
      $selectsSector.val(0);
    }

    init();

    return {
      // init: init,
      getFilters: getCurrentValues,
      setBinding: setBinding,
      clean: cleanFilters
    }
  }

  FiltersCompanies.noConflict = function noConflict() {
    global.FiltersCompanies = previousFiltersCompanies;
    return FiltersCompanies;
  };

  global.FiltersCompanies = FiltersCompanies;
}(this);
